
import { Button, Dropdown, Stack, Table } from "react-bootstrap";
import { hideDialog, showDialog } from "../../support/modal_dialog";
import { characters, makeUniversalBlockKey, modelStore } from "../storage/model";
import { access, isNumber, isString, ToggleButton, useProperty } from "../../support/general";
import $, { isPlainObject } from "jquery"
import {  createAndExecuteMetaChange, createAndExecuteTextChange, executeAddCustomFieldUpdate, executeEditCustomFieldUpdate, executeToggleColumnFieldVisibilityUpdate, makeBlockTextUpdate } from "../storage/changes";
import { EntryIdentifier } from "./EDirectory";
import { AutosizeTextArea } from "../../support/autotext";
import { Cell } from "./Column";
import { hidePopup, showPopup } from "../../support/popup";
import { doChange, makeChange } from "../storage/changes_admin";
import { NavIdentifier } from "./ENavigation";
import { colorCodes, ColorCodeSelector } from "../../support/UxBitsAndPieces";

// const navigationFields = {
//     '-1' : {
//         id  : -1,
//         name : 'text',
//         type : 'test'
//     },
//     '-2' : {
//         id  : -2,
//         name : 'text',
//         type : 'test'
//     }
// }

// const directoryFields = {
//     '-1' : {
//         id  : -1,
//         name : 'text',
//         type : 'text'
//     },
//     '-2' : {
//         id  : -2,
//         name : 'text',
//         type : 'text'
//     }
// }

export function ManageColumns({scriptId,focussedSubscriptId}){

    var fields  = modelStore.useSelector(state=>{
        return getCurrentColumnInfo(state,focussedSubscriptId);
    })
    function onNewCustomField(){
        if (fieldValues && fieldValues.name && fieldValues.type!='none'){
            var fieldId = executeAddCustomFieldUpdate(scriptId,focussedSubscriptId,fieldValues.name,fieldValues.type,focussedSubscriptId);
            executeToggleColumnFieldVisibilityUpdate(scriptId,fieldId,focussedSubscriptId);
            
        }
    }
    var fieldValues = null;
    
    function newCustomField(){
        hideDialog();
        setTimeout(()=>{
            showDialog({
                title : 'New Column',
                message : {tag:NewCustomFieldForm,props:{
                    scriptId,
                    focussedSubscriptId,
                    onValuesChanged : values=>{fieldValues=values},
                }},
                cancel : true,
                ok : 'Create Column',
                onClose : ()=>{onManageColumns(scriptId,focussedSubscriptId)},
                onOk : onNewCustomField
            });
        },0)

    }

    var fieldRows =[];
    if (fields){
        $.each (fields,(f,field)=>{
            fieldRows.push(<FieldRow scriptId = {scriptId} field={field} focussedSubscriptId={focussedSubscriptId}  key={field.id} />)
        });
    }

    return (<div
        style={{
        }}
    >
        <div
            style ={{
                maxHeight : '60vh',
                overflow : 'auto',
                border : 'solid 1px grey',
            }}
        >
            <Table className="no-margin-or-padding" style={{width:'100%'}} >
                <tbody className="no-margin-or-padding">
                    {fieldRows}
                </tbody>
            </Table>
        </div>
        <Button onClick={newCustomField} style={{marginTop:'1em'}}>Create Custom Field</Button>
    </div>);

}

function FieldRow({scriptId,field,focussedSubscriptId}){
    
    var columns = modelStore.useSelector(state=>{
        var loadedScriptId = state.model.loadedScriptId;
        return access(state,['model','Script',loadedScriptId,"subscripts",focussedSubscriptId,"columns"]);
    });
    columns = columns?columns:[];
    
    var isVisible = false;
    $.each(columns,(c,column)=>{
        isVisible = isVisible || (column.fieldId == field.id);
    });
    
    function toggleField(){
        executeToggleColumnFieldVisibilityUpdate(scriptId,field.id,focussedSubscriptId) 
    }

    function onEditField() {

        showDialog({
            title : "Edit field : "+field.name,
            ok : true,
            onOk : applyFieldChanges,
            cancel : true,
            message : { 
                tag : function EditFieldProperty({field,onChange}) {

                    const [getName,setName] = useProperty(field.name);
                    
                    function onNameChanged(e){
                        setName(e.target.value);
                        onChange({
                            name : e.target.value
                        });
                    }
                    return (<div>
                        <div
                            style={{
                                display :'inline-block',
                                width : '7em',
                                textAlign:'right',
                                margin : '1em',
                            }}
                        >Name</div>
                        <input autoFocus  type="text" value={getName()} onChange={onNameChanged} style={{
                            width : '10em'
                        }} />
                    </div> );
                },
                props : {
                    field, 
                    onChange : (fd)=>{
                        fieldData = fd;
                    } 
                }

            }
        });

        var fieldData;

        function applyFieldChanges(){
            executeEditCustomFieldUpdate(scriptId,field.id,fieldData,focussedSubscriptId);
        }
    }

    var editButton = field.isCustom?(
        <Button className="btn-sm " onClick={onEditField}style = {{paddingTop:'0.25em',paddingBottom:'0.25em',paddingLeft:'1em',paddingRight:'1em'}} variant="primary" >Edit</Button> 
    ):(
        <div></div>
    );

    return (<tr className="no-margin-or-padding" >
        <td className="no-margin-or-padding" width="99%" style={{padding:0}} key={1}>
            {field.name}
        </td>
        <td className="no-margin-or-padding" style = {{padding:'0.25em'}} key={2}> 
            {editButton}
        </td>
        <td className="no-margin-or-padding" style = {{padding:'0.25em'}} key={2}> 
            <ToggleButton 
                className="btn-sm" 
                style = {{paddingTop:'0.25em',paddingBottom:'0.25em',paddingLeft:'1em',paddingRight:'1em'}}
                text="Visible" value={isVisible} onChange={toggleField}  
            />
        </td>
        
    </tr>);
}

function NewCustomFieldForm({scriptId,fieldId,onValuesChanged,focussedSubscriptId}){

    var field = access(modelStore,["state","model","Script",scriptId,"subscripts",focussedSubscriptId,"customFields",fieldId]);

    const [getName,setName] = useProperty(field?field.name:"");
    const [getType,setType] = useProperty(field?field.type:"none");
    function onChanged(){
        onValuesChanged({
            name : getName(),
            type : getType(),

        })
    }
    function onNameChanged(e){
        setName(e.target.value);
        onChanged();
    }
    function onTypeChanged(type){
        setType(type);
        onChanged();
    }

    return (<div>
        <div>
            <div
                style={{
                    display :'inline-block',
                    width : '7em',
                    textAlign:'right',
                    margin : '1em',
                }}
            >Name</div>
            <input autoFocus  type="text" value={getName()} onChange={onNameChanged} style={{
                width : '10em'
            }} />
        </div>
        
        <div>
            <div
                style={{
                    display :'inline-block',
                    width : '7em',
                    textAlign:'right',
                    margin : '1em',
                }}
            >Column Type</div>
            <Dropdown 
                style ={{
                    display :'inline-block',
                    width : '20em'
                }}        
            >
                <Dropdown.Toggle  id="dropdown-basic" variant = "primary" 
                    style = {{
                        width : '20em'
                    }}
                >
                    {{
                        none : 'Select a Field Type',
                        text : 'Text',
                        color : 'Color',
                    }[getType()]}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item key="1" onClick={()=>{onTypeChanged('metaText')}}>Text</Dropdown.Item>
                    <Dropdown.Item key="2" onClick={()=>{onTypeChanged('metaColor')}}>Color</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>        
        </div>

    </div>)
}

export function onManageColumns(scriptId,focussedSubscriptId){


    showDialog({
        title : "Columns",
        message : {tag:ManageColumns,props:{scriptId,focussedSubscriptId}},
        ok : 'Close',

    })
}

export const standardFieldDefs = {
    '-navHeading' : {
        id : '-navHeading',
        name : 'Heading',
        obligatory : true,
        type : 'navIdentifier',
        clickStyle : 'documentNavigation'
    },
    '-nav_size' : {
        id : '-nav_size',
        name : 'Size',
        type : 'blockInfo'
    },
    '-nav_page' : {
        id : '-nav_page',
        name : 'Page',
        type : 'blockInfo'
    },
    '-entryName': {
        id : '-entryName', // directory entry name
        name : 'Name',
        obligatory : true,
        type : 'entryIdentifier',
    }
}

export function makeFieldCell(column,scriptId,subscriptId,fieldType,block,indented,columnIndex,eventHandlers,isOccupied,context){
    
    if (fieldType.length>4 && fieldType.substring(0,4)=='meta'){
        return <MetaCell
            scriptId = {scriptId}
            subscriptId = {subscriptId}
            col = {column}
            block = {block}
            key = {column.fieldId}
            columnIndex = {columnIndex}

        />
    } else if (fieldType=='blockInfo') {
        return (<InfoCell
            scriptId = {scriptId}
            col = {column}
            blockId = {block.id}
        />)
    } else {
        switch (fieldType){
            case 'entryIdentifier' : {
                return <EntryIdentifier
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    col = {column}
                    block = {block}
                    onClick = {()=>{eventHandlers['onNavigationLink'](block)}}
                    indented = {indented}
                    key = {column.fieldId}
                />
            } break;
            case 'blockText' : {
                return <Cell
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    col = {column}
                    indented = {indented}
                    key = {column.fieldId}
                    onClick = {()=>{if (eventHandlers.onClick){eventHandlers.onClick(block)}}}
                    style = {{
                        overflowX : 'hidden',
                        textWrap : 'nowrap',
                    }}
                >
                    <span
                        style={{marginLeft:indented+'em'}}
                    >{block.text}</span>
                </Cell>
            } break;
            case 'navIdentifier' : {
                return (<NavIdentifier
                    scriptId = {scriptId}
                    subscriptId = {subscriptId}
                    column = {column}
                    indented = {indented}
                    isOccupied = {isOccupied}
                    block = {block}
                    onClick = {()=>{if (eventHandlers.onClick){eventHandlers.onClick(block)}}}
                    onPlusMinusChanged = {eventHandlers.onPlusMinusChanged}
                    navUnit = {context}
                />);
            } break;
            default : {
                var ii=0;
            }break
        }
    }
}

export function getFieldDef ( state , fieldId , subscriptId) {
    
    var script = state.model.Script[state.model.loadedScriptId];
    var subscript = script.subscripts[subscriptId];
    
    fieldId = fieldId?fieldId:"";
    
    // will need the state parameter for character and tag columns
    switch (fieldId.substring(0,1)){
        case "#" : {   // tag

        }break;
        case "@" : {    // character
            return {
                id : '-nav_character',
                name : fieldId.substring(1),
                type : 'characterCell'
            }
        }break;
        case "-" : {    // standard field
            return standardFieldDefs[fieldId];
        }break;
        case "$" : {    // standard field
            return subscript.customFields[fieldId];
        }break;
    }    
}


export function reorderCurrentColumns(from,to){
    if (from != to){
        modelStore.dispatch(state=>{
            var model = state.model;
            var subscript = model.Script[model.loadedScriptId].subscripts[modelStore.state.model.focussedSubscriptId];
            var columns = subscript.columns?subscript.columns.slice(0):[];
            subscript.columns = columns;
            var column = columns.splice(from,1);
            columns.splice(to,0,column[0]);
        })
    }
}

function getCurrentColumnInfo (state,subScriptId) {

    var customFields = access(state.model,["Script",state.model.loadedScriptId,"subscripts",subScriptId,"customFields"],{});
    // customFields = customFields?customFields:{};

    var fieldIds = [
        '-navHeading',
        '-nav_size',
        '-nav_page',
    ].slice(0);


    var fields = [];
    $.each(fieldIds,(f,fieldId)=>{
        fields.push(getFieldDef(state,fieldId,subScriptId));
    })

    // add custom fields
    $.each( customFields , (f,field)=>{
        fields.push(field)
    })

    var orderedCharacters = []
    $.each(characters,(c,name)=>{
        orderedCharacters.push(name)
    })
    orderedCharacters.sort();
    // fields.push(...orderedCharacters);

    $.each(orderedCharacters,(f,fieldName)=>{
        fields.push({
            id : '@'+fieldName,
            name : fieldName,
            type : 'navCharacter'
        })
    })
    

    // add tag fields

    return fields;
}

export function onMetaChanged(scriptId,subscriptId,block,fieldId,newValue){

    var blockId = isString(block)?parseInt(block):(isNumber(block)?block:block.id);
    var position = modelStore.state.getBlockPosition(scriptId,subscriptId,blockId);
    createAndExecuteMetaChange(scriptId,subscriptId,position,fieldId,[newValue])

}

export function onTextChanged(scriptId,subscriptId,block,newText){
    var blockId = isString(block)?parseInt(block):(isNumber(block)?block:block.id);
    createAndExecuteTextChange(scriptId,subscriptId,blockId,newText);
}


function MetaCell({scriptId,subscriptId,col,block,columnIndex}) {

    var value = block.meta[col.fieldId];
    var field = getFieldDef(modelStore.state,col.fieldId,subscriptId);
    var input = null;

    function onChanged(newValue){
        onMetaChanged(scriptId,subscriptId,block,field.id,newValue)
    }

    switch (field.type){
        case "metaText" : {
            input = <AutosizeTextArea 
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={value}  
                onChange={(value)=>onChanged(value)}
            />
        } break;
        case "metaColor" : {
            input = <ColorMetaCell 
                className="p-0 m-0"
                initial={value}  
                onChange={(value)=>onChanged(value)}
                col={col}
                block = {block}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                columnIndex = {columnIndex}
            />
        } break;
    }
    
    return (
        <Cell col={col} key = {col.fieldId} >
            {input}
        </Cell>
    )

}

function InfoCell ({scriptId,col,blockId}) {

    var value = modelStore.useSelector(state=>{
        return access (state,["model","Block",makeUniversalBlockKey(scriptId,blockId),"info",col.fieldId.substring(5)]);
    });

    function formatLines(value){
        var eighths = Math.round(value/(57/8));
        eighths = eighths?eighths:1;
        var pages = Math.floor(eighths/8);
        var lines = eighths%8;
        return pages?(pages + " " + lines + "/8"): lines + "/8";
    }

    if (value){
        switch (col.fieldId){
            case "-nav_size":{
                value = formatLines(value);
            } break;
            case "-nav_page":{
                value = formatLines(value);
            }break;
        }
    }
    return (<Cell col={col} key = {col.fieldId} style={{
        textAlign : 'center',
    }}>
        {value}
    </Cell>)
}

function ColorMetaCell({scriptId,subscriptId,col,block,columnIndex}){

    var id = "color_"+columnIndex+"_"+makeUniversalBlockKey(scriptId,block.id);
    var value = block.meta[col.fieldId];
    value = value?value:0;
    
    var field = getFieldDef(modelStore.state,col.fieldId,subscriptId);

    function onSelected(colorCode){
        hidePopup();
        onMetaChanged(scriptId,subscriptId,block,field.id,colorCode)
    }

    function onClick(){
        showPopup(
            {
                targetId : id,
                tag : ColorCodeSelector,
                props : {
                    initial : value,
                    onSelected : onSelected,
                }
            }
        );
    }

    return (<div
        id = {id}
        style = {{
            width : '100%',
            height : '100%',
            backgroundColor : colorCodes[value],
            // display : 'block',
            position : 'absolute',
        }}
        onClick={onClick}
    >
        <div></div>
    </div>)
}

// 0 5 A F


